import { Injectable } from '@angular/core';
import { DirectLine } from 'botframework-directlinejs';
import { HttpHeaders } from "@angular/common/http";
import { HttpService } from './../../services/http/http.service';

import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';

import { Observable ,  Subscription } from 'rxjs';
import { SettingsService } from '../../services/settings/settings.service';

@Injectable()
export class ChatBotService {

    private botAuthentication

    private DirectLine

    public user: any;

    private authSubscribe: Subscription;

    private botUrlBase: string;

    constructor(
        private __http: HttpService,
        private store: Store<AppState>,
        private settingsService: SettingsService
    ) {
        // atualiza sempre que tiver uma mudanca no status do usuario
        this.authSubscribe = store.select(s => s.authentication).subscribe(data => {
            this.user = data.currentUser || {
                userId: 900,
                name: 'anonymous',
                token: ''
            };
        });
        // user: 18361009060
        // pass: xptoto

        this.botUrlBase = this.settingsService.getConfigurationKeyValue("bub");
    }

    /**
     * busca um obj de conexao para retornar um socket de conversa com o bot
     */
    startNewConversation() {

        // url para o request do obj
        let botUrlRequest = `${this.botUrlBase}Authentication/StartNewConversation`;

        // Header Authorization: Bearer token, recebe caso tenha algum ususrio logado
        let startConversationHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + this.user.token });

        /**
         * promisse para retornar via http o obj de conexao com o sockect
         */
        return new Promise((resolve, reject) => {
            // request do obj de conexão
            this.__http.get(botUrlRequest, startConversationHeader).subscribe(
                (res: any) => {
                    // salva objeto
                    this.botAuthentication = res;

                    // retorna uma conexão com o socket directline
                    resolve(
                        new DirectLine({
                            token: res.token,
                            streamUrl: res.streamUrl,
                            conversationId: res.conversationId
                        })
                    );
                },
                (err: any) => {
                    switch (err.status) {
                        case 403:
                            reject('Seu login expirou.');
                            break;

                        default:
                            reject('Ops! Por algum motivo não foi possível iniciar uma conversa no chatbot.');
                            break;
                    }
                }
            );
        });
    }

    /**
     * Revona o token de acesso ao socket
     */
    renewToken() {
        // url para renovar o token
        let botUrlRenewToken = 'https://directline.botframework.com/v3/directline/tokens/refresh';

        // header contendo o antigo token para renovar
        let renewTokenPostHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + this.botAuthentication.token });

        /**
         * promisse para buscar via http o novo objeto de conexão
         */
        return new Promise((resolve, reject) => {

            // request para renovar o token
            this.__http.post(botUrlRenewToken, {}, renewTokenPostHeader).subscribe(
                (res: any) => {
                    // atualiza o token salvo
                    this.botAuthentication.token = res.token;
                    // retorna o novo token para reconectar no socket
                    resolve(res);
                },
                (err: any) => {
                    reject('O chatbot está desconectado.');
                }
            );
        });
    }

    /**
     * Desescreve da assinatura de alteracão do usuario
     */
    ngOnDestroy() {
        this.authSubscribe.unsubscribe();
    }
}